import { faqSlice } from "./store/faq.slice";
import {
  faqApi,
  useGetFaqsQuery,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useLazyGetFaqByIdQuery,
  useLazyGetFaqsQuery,
  useDeleteFaqMutation
} from "./api/faq.api";

export const { setFaqs } = faqSlice.actions;

export {
  faqApi,
  faqSlice,
  useGetFaqsQuery,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useLazyGetFaqByIdQuery,
  useLazyGetFaqsQuery,
  useDeleteFaqMutation
};
